export default __webpack_public_path__ + "locales/zh-CN/ChangeEmailDialog.json?hash=204a58cb5d4508cd4d0068a230b2afdf";